/**
 * This a manual file for now until the generated stuff catches back up, but was initially a generated file.
 *
 * was:
 * Do not edit directly
 * Generated on Tue, 27 Sep 2022 21:27:57 GMT
 */

import { Convert } from '#utils/UNSAFE_typeUtils';

const palette = {
  neutral: {
    '0': null,
    '10': null,
    '20': null,
    '30': null,
    '40': null,
    '50': null,
    '60': null,
    '70': null,
    '80': null,
    '90': null,
    '100': null,
    '110': null,
    '120': null,
    '130': null,
    '140': null,
    '150': null,
    '160': null,
    '170': null,
    '180': null,
    '190': null,
    '200': null
  },
  danger: {
    '10': null,
    '20': null,
    '30': null,
    '40': null,
    '50': null,
    '60': null,
    '70': null,
    '80': null,
    '90': null,
    '100': null,
    '110': null,
    '120': null,
    '130': null,
    '140': null,
    '150': null,
    '160': null,
    '170': null,
    '180': null,
    '190': null
  },
  success: {
    '10': null,
    '20': null,
    '30': null,
    '40': null,
    '50': null,
    '60': null,
    '70': null,
    '80': null,
    '90': null,
    '100': null,
    '110': null,
    '120': null,
    '130': null,
    '140': null,
    '150': null,
    '160': null,
    '170': null,
    '180': null,
    '190': null
  },
  warning: {
    '10': null,
    '20': null,
    '30': null,
    '40': null,
    '50': null,
    '60': null,
    '70': null,
    '80': null,
    '90': null,
    '100': null,
    '110': null,
    '120': null,
    '130': null,
    '140': null,
    '150': null,
    '160': null,
    '170': null,
    '180': null,
    '190': null
  },
  info: {
    '10': null,
    '20': null,
    '30': null,
    '40': null,
    '50': null,
    '60': null,
    '70': null,
    '80': null,
    '90': null,
    '100': null,
    '110': null,
    '120': null,
    '130': null,
    '140': null,
    '150': null,
    '160': null,
    '170': null,
    '180': null,
    '190': null
  },
  brand: {
    '10': null,
    '20': null,
    '30': null,
    '40': null,
    '50': null,
    '60': null,
    '70': null,
    '80': null,
    '90': null,
    '100': null,
    '110': null,
    '120': null,
    '130': null,
    '140': null,
    '150': null,
    '160': null,
    '170': null,
    '180': null,
    '190': null
  }
};

const overlay = {
  hover: null,
  active: null,
  dangerHover: null,
  dangerActive: null,
  scrim: null,
  inverseHover: null,
  inverseActive: null
};

const pageBackground = {
  neutral0: null,
  neutral10: null,
  neutral20: null,
  neutral30: null,
  neutral40: null
};

const surface = {
  neutral0: null,
  neutral10: null,
  neutral20: null,
  neutral30: null,
  selected: null,
  disabled: null,
  popup: null,
  neutral: {
    low: null,
    subtle: null,
    strong: null
  },
  success: {
    low: null,
    subtle: null,
    strong: null
  },
  info: {
    low: null,
    subtle: null,
    strong: null
  },
  warning: {
    low: null,
    subtle: null,
    strong: null
  },
  danger: {
    low: null,
    subtle: null,
    strong: null
  }
};

const border = {
  enabled: null,
  disabled: null,
  divider: null,
  selected: null,
  dropLine: null,
  selectedNeutral: null,
  warning: null,
  danger: null,
  keyboardFocus: null
};

const boxshadow = {
  shadowcolor: null
};

const textIcon = {
  primary: null,
  secondary: null,
  disabled: null,
  inverse: null,
  onColor: null,
  link: null,
  success: null,
  info: null,
  warning: null,
  danger: null
};

// TODO: move this to the TextField component theme code JET-61936
const textfield = {
  surface: {
    enabled: null
  },
  border: {
    enabled: null
  }
};

const collection = {
  header: {
    text: null,
    surface: {
      selected: null,
      partialSelected: null
    }
  }
};

const collectionGrid = {
  cell: {
    surfaceEdit: null
  }
};

const measure = {
  track: {
    enabled: null,
    disabled: null
  },
  fill: {
    enabled: null,
    disabled: null
  },
  thumb: {
    surface: null
  },
  reference: {
    line: null,
    lineContrast: null,
    area: null
  }
};

const dvt = {
  contrastLine: null,
  paletteQualitative: {
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
    6: null,
    7: null,
    8: null,
    9: null,
    10: null,
    11: null,
    12: null
  },
  threshold: {
    success: null,
    warning: null,
    danger: null
  },
  marquee: {
    border: null,
    surface: null
  },
  referenceObject: {
    area: null,
    line: null
  },
  overview: {
    background: null,
    windowBackground: null,
    windowBorder: null
  }
};

type ColorScheme = Convert<string, typeof colorScheme>;

const colorScheme = {
  palette,
  overlay,
  pageBackground,
  surface,
  border,
  boxshadow,
  textIcon,
  textfield,
  collection,
  collectionGrid,
  measure,
  dvt
};

const typography = {
  heading: {
    xs: {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    },
    sm: {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    },
    md: {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    },
    lg: {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    },
    xl: {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    },
    '2xl': {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    }
  },
  subheading: {
    '2xs': {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    },
    xs: {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    },
    sm: {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    },
    md: {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    },
    lg: {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    },
    xl: {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    },
    '2xl': {
      lineHeight: null,
      fontSize: null,
      fontWeight: null
    }
  },
  body: {
    '2xs': {
      lineHeight: null,
      fontSize: null,
      fontWeight: {
        regular: null,
        semibold: null,
        bold: null
      }
    },
    xs: {
      lineHeight: null,
      fontSize: null,
      fontWeight: {
        regular: null,
        semibold: null,
        bold: null
      }
    },
    sm: {
      lineHeight: null,
      fontSize: null,
      fontWeight: {
        regular: null,
        semibold: null,
        bold: null
      }
    },
    md: {
      lineHeight: null,
      fontSize: null,
      fontWeight: {
        regular: null,
        semibold: null,
        bold: null
      }
    },
    lg: {
      lineHeight: null,
      fontSize: null,
      fontWeight: {
        regular: null,
        semibold: null,
        bold: null
      }
    },
    xl: {
      lineHeight: null,
      fontSize: null,
      fontWeight: {
        regular: null,
        semibold: null,
        bold: null
      }
    }
  }
};

export type { ColorScheme };
export { typography, colorScheme };
